const CardDocuments = (item, colorScheme) => {
  const { pretitle, title, description, file } = item

  return {
    pretitle,
    title,
    description,
    cta: {
      label: 'Download',
      href: file.url
    },
    parentColorScheme: colorScheme
  }
}

export default CardDocuments